<itb-dropdown-list [dropDownButton]="dropDownButton" [items]="items"  (onClickHandler)="closeSidePull($event)"
                   *ngIf=" user.userType === 'internal'" ></itb-dropdown-list>
